import { TriggerCreate } from "@dots-projects/types";
import { v4 as uuidv4 } from "uuid";

export const bookmarkMessages = (
  workspace: string
): {
  trigger: TriggerCreate;
  gif: any;
  title: string;
  description: string;
} => {
  return {
    title: "Bookmark messages",
    description: "TODO",
    gif: "TODO",
    trigger: {
      name: "Bookmark messages",
      type: "button_click",
      platform: "discord",
      communityId: localStorage.getItem("guild-id") || "",
      authorUserId: localStorage.getItem("discord-id") || "",
      workspace,
      isDraft: true,
      configs: {
        messages: [
          {
            id: uuidv4(),
            buttonIds: [uuidv4()],
          },
        ],
        responseOnError: "Something went wrong, please try again!",
        $$editorPosition: { x: 0, y: 0 },
        responseOnComplete: "Success! Please continue.",
        $$editorButtonClickContent: {
          message: "Bookmark messages! Click below to see how",
          buttonText: "Instructions",
          buttonEmoji: "🗃️",
          channelId: "1075908920138289285",
          htmlMessage: "<p>Bookmark messages! Click below to see how</p>",
        },
      },
      steps: [
        {
          id: "embed-msg-send_message-0-5VWRVo",
          type: "send_message",
          configs: {
            message:
              '{"content": "Instructions:",\n    "embeds": [\n        {\n            "title": "Bookmark messages",\n            "color": 15695665,\n            "url": "https://discord.com",\n            "author": {\n                "url": "https://discord.com"\n            },\n            "image": {\n                "url": "https://media.discordapp.net/attachments/1075913859048673421/1077378735457697852/unnamed.jpg?width=1604&height=960"\n            },\n            "fields": [\n                {\n                    "name": "Step 1",\n                    "value": "Right click a message to save it"\n                },\n                {\n                    "name": "Step 2",\n                    "value": "Optionally add tags",\n                    "inline": false\n                },\n                {\n                    "name": "Step 3",\n                    "value": "Access it in [Dots dashboard](https://app.dots.community/messages/)",\n                    "inline": false\n                }\n            ]\n        }\n    ]\n}',
            channelId: "{{interaction.channelId}}",
            ephemeral: true,
            delaySeconds: 0,
            sendBrandingIfNotPremium: true,
            $$editorPosition: { x: 0, y: 200 },
            $$editorPositionWhenNode: { x: 0, y: 200 },
          },
          isEntry: true,
          isGoal: false,
          name: "Bookmark messages instructions",
          transitions: [{ targetStepId: "embed-msg-send_message-0-SMwcuW" }],
        },
        {
          type: "send_message",
          name: "Send a embed message",
          id: "embed-msg-send_message-0-SMwcuW",
          configs: {
            channelId: "$channelId",
            message:
              '{"content": "Example:",\n    "embeds": [\n        {\n            "color": 15695665,\n            "url": "https://discord.com",\n            "author": {\n                "url": "https://discord.com"\n            },\n            "image": {\n                "url": "https://media.discordapp.net/attachments/1075913859048673421/1077392652397461544/gif.gif"\n            }\n        }\n    ]\n}',
            ephemeral: true,
            delaySeconds: 0,
            $$editorPosition: { x: 0, y: 400 },
            $$editorPositionWhenNode: { x: 0, y: 200 },
          },
          transitions: [],
        },
      ],
    },
  };
};
